import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";
import { ProjectSelect } from "@/components/common";

const FIELDS = [["company_name", "Public company name"], ["phone", "Official contact number"], ["email", "Business email"], ["website", "Website"], ["address", "Project location / sales office"],
  ["rera", "RERA registration (approved)"], ["disclaimer", "Disclaimer"], ["instagram", "Instagram handle"], ["facebook", "Facebook page"], ["cta", "Call to action (e.g. Book a Site Visit)"]];

export function FooterPanel({ canWrite }) {
  const [scope, setScope] = useState("org");
  const [pid, setPid] = useState("");
  const [f, setF] = useState({ fields: {}, show: {} });
  const project = scope === "project" ? pid : undefined;
  useEffect(() => {
    api.get("/footer", { params: { project_id: project } }).then((r) => {
      const src = scope === "project" ? r.data.project : r.data.org;
      setF({ fields: src.fields || {}, show: src.show || {}, inherited: r.data.fields });
    });
  }, [scope, project]);
  const save = async () => {
    try { await api.put("/footer", { project_id: project || null, fields: f.fields, show: f.show }); toast.success("Footer & contact saved"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="lx-card max-w-5xl mt-6 space-y-4" data-testid="footer-panel">
      <div><div className="font-semibold">Footer & Contact (shown on creatives and shared reports)</div>
        <p className="text-xs text-slate-400 mt-1">Only what you type and switch on here is shown publicly. Until you add a public company name, creatives show no company name. Never enter details you haven't verified.</p></div>
      <div className="flex flex-wrap items-center gap-2">
        <Button size="sm" variant={scope === "org" ? "default" : "secondary"} onClick={() => setScope("org")} data-testid="footer-scope-org">Company default</Button>
        <Button size="sm" variant={scope === "project" ? "default" : "secondary"} onClick={() => setScope("project")} data-testid="footer-scope-project">Project override</Button>
        {scope === "project" && <ProjectSelect value={pid} onChange={setPid} testid="footer-project-select" />}
      </div>
      <div className="grid md:grid-cols-2 gap-4">{FIELDS.map(([k, l]) => (
        <div key={k} className="space-y-1">
          <div className="flex items-center justify-between"><Label className="text-xs">{l}</Label>
            <label className="flex items-center gap-1 text-[11px] text-slate-500"><Switch checked={f.show[k] !== false} onCheckedChange={(v) => setF({ ...f, show: { ...f.show, [k]: v } })} disabled={!canWrite} data-testid={`footer-show-${k}`} />Show</label></div>
          <Input value={f.fields[k] || ""} disabled={!canWrite} placeholder={scope === "project" ? (f.inherited?.[k] || "Uses company default") : ""} onChange={(e) => setF({ ...f, fields: { ...f.fields, [k]: e.target.value } })} data-testid={`footer-field-${k}`} />
        </div>))}</div>
      {canWrite && <Button onClick={save} disabled={scope === "project" && !pid} data-testid="footer-save-button">Save footer & contact</Button>}
    </div>
  );
}
